import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { observer, inject } from "mobx-react";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Box,
  Container,
  Grid,
} from "@mui/material";

import { DatePicker } from "@mui/x-date-pickers";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardActions,
} from "@mui/material";
import TopBarMenu from "../../components/common/TopBarMenu";

import {
  getTrainers,
  deleteTrainer,
  upsertTrainer,
} from "../../utils/api/Meeting/Dashboard/Trainer";
import { IMaskInput } from "react-imask";
import PropTypes from "prop-types";
import dayjs from "dayjs";

const PersonelPage = ({ store }) => {
  const navigate = useNavigate();
  const [trainerList, setTrainerList] = useState([]);
  const [trainerDialog, setTrainerDialog] = useState(false);
  const [trainer, setTrainer] = useState({
    trainerId: 0,
    name: "Sinan",
    surname: "Mutlu",
    email: "mutlusinanmutlu@gmail.com ",
    mobilePhone: 5068110775,
    birthDate: dayjs(),
    gender: 1,
    userType: 52,
    avatar: "",
  });
  // const [trainer, setTrainer] = useState({
  //   trainerId: 0,
  //   name: "",
  //   surname: "",
  //   email: "",
  //   mobilePhone: 5,
  //   birthDate: dayjs(),
  //   gender: 1,
  //   userType: 2,
  //   avatar: "",
  // });

  useEffect(() => {
    if (!store.isLogin) {
      store.setLoadingBarStatus(true);
      navigate("/panel/kullanici-girisi");
    } else {
      getTrainersReq();
    }
  }, []);

  const handleTrainerDialog = () => {
    setTrainerDialog(!trainerDialog);
  };

  const getTrainersReq = async (klinikId) => {
    store.setLoadingBarStatus(false);

    let getTrainersRes = await getTrainers(
      store.baseUrl,
      store.token,
      store.trainer.id
    );
    if (getTrainersRes !== null && getTrainersRes !== undefined) {
      if (getTrainersRes.status === 200) {
        if (getTrainersRes.data !== null) {
          setTrainerList(getTrainersRes.data.data);
        } else {
          setTrainerList([]);
        }
      }
    }
    store.setLoadingBarStatus(true);
  };

  const onClickUpdateTrainer = (updateTrainer) => {
    updateTrainer.birthDate = dayjs(updateTrainer.birthDate);
    setTrainer(updateTrainer);
    handleTrainerDialog();
  };

  const onClickUpsertTrainer = async () => {
    if (
      trainer.name === "" ||
      trainer.surname === "" ||
      trainer.mobilePhone.toString().length !== 10 ||
      trainer.birthDate === null ||
      trainer.gender === 0 ||
      trainer.email === 0
    )
      return store.setMessage("Lütfen tüm alanları doldurunuz.", true, "error");
    let insertTrainerRes = await upsertTrainer(
      store.baseUrl,
      store.token,
      trainer
    );
    if (insertTrainerRes !== null && insertTrainerRes !== undefined) {
      if (insertTrainerRes.status === 200) {
        store.setMessage("Personel başarıyla oluşturuldu.", true, "success");
        handleTrainerDialog();
        await getTrainersReq();
      } else {
        store.setMessage(
          insertTrainerRes?.data?.message ??
            "Personel oluşturulurken hata oluştu.",
          true,
          "error"
        );
      }
    } else {
      store.setMessage("Personel oluşturulurken hata oluştu.", true, "error");
    }
  };

  const deleteTrainerReq = async (trainerId) => {
    store.setLoadingBarStatus(false);

    let deleteKlinikEmployeeResponse = await deleteTrainer(
      store.baseUrl,
      store.token,
      trainerId
    );
    if (
      deleteKlinikEmployeeResponse !== null &&
      deleteKlinikEmployeeResponse !== undefined
    ) {
      if (deleteKlinikEmployeeResponse.status === 200) {
        store.setMessage(
          "Personel silme işlemi başarıyla tamamlandı.",
          true,
          "success"
        );
        await getTrainersReq();
      } else {
        store.setMessage(
          deleteKlinikEmployeeResponse.data.message,
          true,
          "error"
        );
      }
    } else {
      store.setMessage("Personel silinirken hata oluştu.", true, "error");
    }
    store.setLoadingBarStatus(true);
  };

  const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, name, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="(#00)000-0000"
        definitions={{
          "#": /[1-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name, value } })}
        overwrite
      />
    );
  });

  TextMaskCustom.propTypes = {
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  return (
    <div className="container mps-container">
      <TopBarMenu meeting />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          pt: 9,
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={3}>
            <Grid item style={{ height: "100%", width: "100%" }}>
              <Card>
                <CardHeader title="Personel Yönetimi" />

                <CardActions sx={{ margin: "15px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleTrainerDialog}
                  >
                    Yeni Personel Ekle
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>navigate("/project")}
                    style={{ marginInlineStart: "auto" }}
                  >
                    Geri
                  </Button>
                </CardActions>
                <CardContent style={{ paddingTop: "0", height: "100%" }}>
                  <TableContainer style={{ marginTop: "0px" }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>ADI</TableCell>
                          <TableCell>SOYADI</TableCell>
                          <TableCell>GÖREVİ</TableCell>
                          <TableCell>E-POSTA ADRESİ</TableCell>
                          <TableCell>İŞLEMLER</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {trainerList.map((trainer, idx) => (
                          <TableRow key={idx}>
                            <TableCell>
                              <Typography variant="body2">
                                {trainer.name}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {trainer.surname}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {trainer.userType === 1
                                  ? "Süpervizör"
                                  : "Görüşmeci"}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography variant="body2">
                                {trainer.email}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              {trainer.userType !== 1 ? (
                                store.trainer !== undefined ? (
                                  trainer.trainerId ===
                                  store.trainer.id ? null : (
                                    <Button
                                      variant="contained"
                                      color="warning"
                                      onClick={() =>
                                        onClickUpdateTrainer(trainer)
                                      }
                                      style={{
                                        marginRight: "10px",
                                      }}
                                    >
                                      Güncelle
                                    </Button>
                                  )
                                ) : null
                              ) : null}
                              {store.trainer !== undefined ? (
                                trainer.trainerId ===
                                store.trainer.id ? null : (
                                  <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() =>
                                      deleteTrainerReq(trainer.trainerId)
                                    }
                                  >
                                    Sil
                                  </Button>
                                )
                              ) : null}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={trainerDialog}
        onClose={handleTrainerDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {trainer.trainerId > 0 ? "Personel Güncelle" : "Personel Ekle"}
        </DialogTitle>
        <DialogContent style={{ padding: "30px", paddingTop: "0" }}>
          <TextField
            id="outlined-basic"
            variant="outlined"
            name="mobilePhone"
            value={trainer.mobilePhone}
            type="text"
            style={{
              width: "100%",
              marginBottom: "10px",
              borderRadius: "10px",
              marginTop: "10px",
            }}
            label="Cep Telefonu Numarası*"
            onChange={(e) =>
              setTrainer({ ...trainer, mobilePhone: e.target.value })
            }
            disabled={trainer.trainerId > 0}
          />
          <TextField
            name="name"
            value={trainer.name}
            label="Adı*"
            style={{ width: "100%", marginTop: "10px" }}
            onChange={(e) => setTrainer({ ...trainer, name: e.target.value })}
          />
          <TextField
            name="surname"
            value={trainer.surname}
            label="Soyadı*"
            style={{ width: "100%", marginTop: "10px" }}
            onChange={(e) =>
              setTrainer({ ...trainer, surname: e.target.value })
            }
          />
          <TextField
            name="email"
            value={trainer.email}
            label="E-posta*"
            style={{ width: "100%", marginTop: "10px" }}
            onChange={(e) => setTrainer({ ...trainer, email: e.target.value })}
          />
          <FormControl fullWidth style={{ marginTop: "10px" }}>
            <DatePicker
              label="Personel Doğum Tarihi*"
              value={trainer.birthDate}
              onChange={(newValue) =>
                setTrainer({ ...trainer, birthDate: newValue })
              }
              renderInput={(params) => <TextField {...params} />}
              resizable
            />
          </FormControl>
          <FormControl style={{ marginTop: "10px" }}>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Cinsiyet*
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel
                value="erkek"
                control={
                  <Radio
                    onChange={() => setTrainer({ ...trainer, gender: 1 })}
                  />
                }
                label="Erkek"
                checked={trainer.gender === 1}
              />
              <FormControlLabel
                value="kadın"
                control={
                  <Radio
                    onChange={() => setTrainer({ ...trainer, gender: 2 })}
                  />
                }
                label="Kadın"
                checked={trainer.gender === 2}
              />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTrainerDialog}>Kapat</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={onClickUpsertTrainer}
          >
            {trainer.trainerId > 0 ? "Güncelle" : "Ekle"}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default inject("store")(observer(PersonelPage));
